import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Deep merge: objects merge recursively, arrays and scalars are replaced. */
export function deepMerge(base, override) {
  if (override === undefined || override === null) return base;
  if (Array.isArray(base) || Array.isArray(override)) return override;
  if (typeof base !== "object" || typeof override !== "object") return override;
  const out = { ...base };
  Object.keys(override).forEach((k) => {
    out[k] = k in base ? deepMerge(base[k], override[k]) : override[k];
  });
  return out;
}

/**
 * Merge the editable overrides stored in the back-office on top of the
 * default (code) content of a page. Falls back silently to the defaults.
 */
export function usePageContent(pageKey, lang, defaults) {
  const [content, setContent] = useState(defaults);

  useEffect(() => {
    setContent(defaults);
    let alive = true;
    api
      .get(`/page-content/${pageKey}?lang=${lang}`)
      .then((r) => {
        const data = r.data?.data;
        if (alive && data && Object.keys(data).length) setContent(deepMerge(defaults, data));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [pageKey, lang, defaults]);

  return content;
}
